/* eslint no-useless-escape: 0 */

const lux = "The light fades and it's all you get\nTidal forces argumentative\nJettisoned in an astral fit\nOxygen supply down to less than 1%\nFading out in a radar blip\nWhen/where/why are totally irrelevant\nWhen/where/why are suddenly  apparent\nThe waves do what they want\nParticle or not\nThe waves form peaks and troughs\nParticle or not\nIs that what you are?\nParticle or not";

export default lux;